module.exports = __webpack_public_path__ + "img/2.e3359e50.png";